<div *ngIf="downloadURL" class="mt-2">
    <span>Attachment: </span>
    <a [href]="downloadURL" download>
        {{attachment.AttachmentFileName}}
    </a>
</div>
<div class="card-body" *ngIf="pdfUrl">
    <iframe [src]="pdfUrl" style="width: 100%; height: 750px;"></iframe>
</div>
